import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import ReactSVG from 'react-svg';
import question from '../assets/graphics/question.svg';
import IconButton from "./icon-button";

class HelpButton extends Component {

    constructor( props ){
        super(props);

        this._goToHelp = this._goToHelp.bind(this);
    }

    _goToHelp() {
        const { goToHelp } = this.props;
        goToHelp();
    }

    render() {
        return(
          <IconButton className="icon-btn-help" onClick={ this._goToHelp }>
              <ReactSVG src={ question } className="question" />
          </IconButton>
        );
    }

}

const mapDispatchToProps = ( dispatch ) => {
    return {
        goToHelp: () => {
            dispatch( push('/help') );
        }
    };
};

export default connect(null,mapDispatchToProps)(HelpButton);


// WEBPACK FOOTER //
// ./src/components/help-button.js